import React, { useState } from 'react';
import { useNavigate } from 'react-router';

import styled from '@emotion/styled';

import { FormSubmitButton } from '../../../components/Button/FormSubmitButton';
import ArrowIcon from '../../../components/Icons/ArrowIcon';
import ShareIcon from '../../../components/Icons/ShareIcon';
import ShareLargeIcon from '../../../components/Icons/ShareLargeIcon';
import UserIcon from '../../../components/Icons/UserIcon';
import { Modal } from '../../../components/Modal/Modal';
import UploadExcelFileModal from '../../../components/Modal/ModalActions/UploadExcelFileModal/UploadExcelFileModal';
import useDownloadDriverTemplate from '../../../hooks/dashboard/driver-setup/useDownloadDriverTemplate';
import { SINGLE_DRIVER_SETUP } from '../../../routes/routeConstants';

const SetupDriverList = () => {
  const [showModal, setShowModal] = useState(false);
  const { downloadDriverTemplate, loading: loadingDownload } =
    useDownloadDriverTemplate();
  const navigate = useNavigate();

  const navToSingleDriverSetup = () => {
    navigate(`/${SINGLE_DRIVER_SETUP}`);
  };

  const handleDownloadTemplate = () => {
    downloadDriverTemplate();
  };

  return (
    <Container>
      <Title>How would you like to set up your driver list?</Title>
      <BoxArea>
        {/* left */}
        <Box>
          <IconArea>
            <UserIcon />
          </IconArea>
          <BoxTextArea>
            <BoxBoldText>Single Entry</BoxBoldText>
            <BoxText>
              Add driver credentials one at a time. Best suited for
              organizations with one or two drivers.
            </BoxText>
          </BoxTextArea>
          <FormSubmitButton
            onClick={navToSingleDriverSetup}
            btnType='button'
            className='fit full-mobile'
          >
            Proceed <ArrowIcon />
          </FormSubmitButton>
        </Box>

        {/* Right */}
        <Box>
          <IconArea>
            <ShareLargeIcon />
          </IconArea>
          <BoxTextArea>
            <BoxBoldText>Multiple entry</BoxBoldText>
            <BoxText>
              Upload bulk driver credentials using Excel. Recommended for
              organizations with more than two drivers.
            </BoxText>
          </BoxTextArea>

          <ButtonArea>
            <FormSubmitButton
              onClick={handleDownloadTemplate}
              btnType='button'
              className='clear fill'
              loading={loadingDownload}
            >
              Download Template
            </FormSubmitButton>

            <FormSubmitButton
              onClick={() => setShowModal(true)}
              btnType='button'
              className='fit'
            >
              Upload Excel File <ShareIcon />
            </FormSubmitButton>
          </ButtonArea>
        </Box>
      </BoxArea>
      <Modal showModal={showModal} setShowModal={setShowModal}>
        <UploadExcelFileModal />
      </Modal>
    </Container>
  );
};

export default SetupDriverList;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 4px;

  /* border: 1px solid red; */
`;

const Title = styled.div`
  font-weight: 600;
  font-size: 22px;
  line-height: 22px;
  color: #232222;
`;

const BoxArea = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 28px;

  @media (max-width: 884px) {
    display: flex;
    flex-direction: column;
  }
`;

const Box = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 28px;
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  background-color: white;

  @media (max-width: 884px) {
    padding: 20px;
  }
`;

const IconArea = styled.div`
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.palette.logiratePrimaryLight};
  border-radius: 8px;
`;

const BoxTextArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: #232222;
`;

const BoxBoldText = styled.div`
  font-weight: 600;
  font-size: 18px;
  line-height: 18px;
`;

const BoxText = styled.div`
  gap: 20px;
  color: ${({ theme }) => theme.palette.grayTextColor};
  font-size: 16px;
  /* line-height: 16px; */
`;

const ButtonArea = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`;
